import React, { useState } from "react";
import { scrollTo } from "../../service/scroll";
import "./Navigation.scss";

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const goTo = (section: string) => (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setOpen(false);
    scrollTo(section);
  };
  return (
    <nav id="mainNav" className="site-nav" aria-label="Main navigation">
      <div className="site-width nav-inner">
        <a className="nav-brand" href="#video" onClick={goTo("#video")}>KLOCK<span> / </span>CONSULTING<span className="brand-dot">.</span></a>
        <button className="nav-toggle" type="button" aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} aria-controls="site-links" onClick={() => setOpen(!open)}>{open ? "Close" : "Menu"}<span aria-hidden="true">{open ? "×" : "☰"}</span></button>
        <div id="site-links" className={`nav-links${open ? " is-open" : ""}`}>
          <a href="#portfolio" onClick={goTo("#portfolio")}>Work</a>
          <a href="#about" onClick={goTo("#about")}>About</a>
          <a href="#skills" onClick={goTo("#skills")}>Expertise</a>
          <a className="nav-contact" href="mailto:TobiasKlock84@gmail.com">Let’s talk <span aria-hidden="true">↗</span></a>
        </div>
      </div>
    </nav>
  );
}
